import BaseController from 'lib/base-controller';
import VideoScrollAction from 'lib/video-scroll-action';
import GalleryScrollAction from 'lib/gallery-scroll-action';
import StockistsModal from 'lib/stockists';
import Video from 'lib/video';

import MainTemplate from 'templates/main.html';


/**
 * MainController
 *
 * Basically index of the website
 */
export default class MainController extends BaseController {

    /**
     * constructor
     */
    constructor (props, renderDone) {
        super();

        this.template = MainTemplate;
        this.context = {
            hashtag: '#noisymayinfluenced',
            influencersTitle: 'meet the influencers',
            influencers: this.getInfluencers(),
            quoteCopy: 'it’s really inspiring to be able to share this experience with all these talented girls',
            quoteAuthor: 'deau',
            exploreTitle: 'city guides',
            cities: this.getCities(),
        };
        this.renderDone = renderDone;

        this.render();
    }

    /**
     * Destructor
     *
     * @param  {Function} done
     */
    destructor (done) {
        this.videoScrollAction.destructor();
        this.influencerScrollAction.destructor();
        this.cityScrollAction.destructor();

        done();
    }

    /**
     * afterRender
     *
     * After render callback, to mainly initialize animation
     */
    afterRender () {
        super.afterRender();

        new StockistsModal(document.querySelector('.js-stockists-copy'));

        this.videoScrollAction = new VideoScrollAction(document.querySelector('.js-teaser-scroll-action'));
        this.influencerScrollAction = new GalleryScrollAction(document.querySelector('.js-influencers-scroll-action'), true);
        this.cityScrollAction = new GalleryScrollAction(document.querySelector('.js-cities-scroll-action'), true);

        this.initVideo();
        this.renderDone();
    }

    initVideo () {
        new Video(document.querySelector('[data-player="container"]'));
    }

    /**
     * getInfluencers
     *
     * Returns hardcoded array of influencer objects
     *
     * @return {Array}
     */
    getInfluencers () {
        return [
            {
                name: 'nanda schwarz',
                img: '/media/img/influencers/nanda/nanda-schwarz_thumb.jpg',
                url: '/influencer/nanda-schwarz'
            },
            {
                name: 'lisa fiege',
                img: '/media/img/influencers/lisa/lisa-fiege_thumb.jpg',
                url: '/influencer/lisa-fiege'
            },
            {
                name: 'urban traveller',
                img: '/media/img/influencers/rachel/urban-traveller_thumb.jpg',
                url: '/influencer/urban-traveller'
            },
            {
                name: 'deau',
                img: '/media/img/influencers/deau/deau_thumb.jpg',
                url: '/influencer/deau'
            },
            {
                name: 'charlotte martin',
                img: '/media/img/influencers/charlotte/charlotte-martin_thumb.jpg',
                url: '/influencer/charlotte-martin'
            },
            {
                name: 'olivia by nature',
                img: '/media/img/influencers/olivia/olivia-by-nature_thumb.jpg',
                url: '/influencer/olivia-by-nature'
            },
        ];
    }

    /**
     * getCities
     *
     * Returns hardcoded array of city objects
     *
     * @return {Array}
     */
    getCities () {
        return [
            {
                name: 'london',
                img: '/media/img/cities/london_thumb.jpg',
                url: '/city/london'
            },
            {
                name: 'berlin',
                img: '/media/img/cities/berlin_thumb.jpg',
                url: '/city/berlin'
            },
            {
                name: 'amsterdam',
                img: '/media/img/cities/amsterdam_thumb.jpg',
                url: '/city/amsterdam'
            },
        ];
    }
}



// WEBPACK FOOTER //
// ./controllers/main.js